"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInstallmentsOrderBy = void 0;

var _orderBy = require("./order-by");

var _productTypes = require("./product-types");

const ProductInstallmentsOrderBy = {
  [_productTypes.ProductTypes.HOME]: _orderBy.OrderBy.MAX,
  [_productTypes.ProductTypes.AUTO]: _orderBy.OrderBy.MAX
};
exports.ProductInstallmentsOrderBy = ProductInstallmentsOrderBy;